import { Pipe, PipeTransform } from '@angular/core';


/**
    splits `items` into `desiredColumns`, but only if `minItemsPerColumn` is satisfied
*/
@Pipe({
    name: 'split',
})
export class SplitPipe implements PipeTransform {

    transform<T>(items: T[], desiredColumns: number, minItemsPerColumn = 1): T[][] {
        const result: T[][] = [];
        const maxRowsPerColumn = Math.max(Math.ceil(items.length / desiredColumns), minItemsPerColumn);
        const actualColumns = Math.ceil(items.length / maxRowsPerColumn);
        for (let i = 0; i < actualColumns; i++) {
            result.push(items.slice(maxRowsPerColumn * i, maxRowsPerColumn * (i + 1)));
        }
        return result;
    }
}
